/*
 * @Description: 中转页常量配置
 */

import { i18n } from '@/i18n';

// 微汇款logo图片url
export const WEREMIT_LOGO = '//st.moneydata.hk/res/fmd_mojo_static/NSAQmvZDveUgXQblXNuSnRcbu61cwZIv.png';

// 微汇款标题
export const WEREMIT_TITLE = '微汇款';

// 感叹号提示logo图片url
export const WARNING_LOGO = '//st.moneydata.hk/res/fmd_mojo_static/DRFIvKxC6evP5lJ7FF1A9X61FUK5hR0z.png';

// 异常提示标题
export const WARNING_TITLE = i18n('链接无法访问');

// PC端在移动端打开链接标题
export const OPEN_IN_MOBILE_TITLE = i18n('请在移动端打开链接');

// 版权信息
export const COPYRIGHT_TEXT = i18n('本服务由Tenpay Global 跨境汇款（腾讯金融科技旗下官方跨境汇款平台）提供');
